// Codira shared test IDs
export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  loginBtn: "auth-login-btn",
  registerBtn: "auth-register-btn",
  toRegisterLink: "auth-to-register-link",
  toLoginLink: "auth-to-login-link",
  errorMsg: "auth-error-msg",
};

export const NAV = {
  logo: "nav-logo",
  dashboard: "nav-dashboard",
  campaigns: "nav-campaigns",
  templates: "nav-templates",
  renders: "nav-renders",
  assets: "nav-assets",
  social: "nav-social",
  performance: "nav-performance",
  settings: "nav-settings",
  newCampaignBtn: "nav-new-campaign-btn",
  logoutBtn: "nav-logout-btn",
};

export const CAMPAIGN = {
  createBtn: "campaign-create-btn",
  saveBtn: "campaign-save-btn",
  nameInput: "campaign-name-input",
  objectiveSelect: "campaign-objective-select",
  descTextarea: "campaign-desc-textarea",
  brandColorInput: "campaign-brand-color-input",
  card: (id) => `campaign-card-${id}`,
};

export const VARIATION = {
  newBtn: "variation-new-btn",
  aiGenBtn: "variation-ai-gen-btn",
  renderAllBtn: "variation-render-all-btn",
  aiBrandInput: "ai-brand-input",
  aiProductInput: "ai-product-input",
  aiAudienceInput: "ai-audience-input",
  aiToneInput: "ai-tone-input",
  aiCountInput: "ai-count-input",
  aiSubmitBtn: "ai-submit-btn",
  card: (id) => `variation-card-${id}`,
};

export const RENDER = {
  zipBtn: "render-zip-btn",
  retryBtn: (id) => `render-retry-${id}`,
  card: (id) => `render-card-${id}`,
  publishBtn: (id) => `render-publish-${id}`,
};

export const TEMPLATE = {
  uploadInput: "template-upload-input",
  uploadBtn: "template-upload-btn",
  card: (id) => `template-card-${id}`,
};

export const SOCIAL = {
  connectMetaBtn: "social-connect-meta-btn",
  disconnectMetaBtn: "social-disconnect-meta-btn",
};

export const ASSET = {
  uploadInput: "asset-upload-input",
};

export const SEED = {
  seedBtn: "seed-demo-btn",
};
